import CampaignPeriod from './CampaignPeriod'

export default CampaignPeriod
